import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCiLX4wfgEbrf4ejBlQef8fOxsoPDLdrNs",
  authDomain: "auctoris-dealer.firebaseapp.com",
  projectId: "auctoris-dealer",
  storageBucket: "auctoris-dealer.firebasestorage.app",
  messagingSenderId: "889959028104",
  appId: "1:889959028104:web:71f810d8d047b29bbc563d"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
